import React from "react";
import PropTypes from "prop-types";

import { getUrlParams } from "utils/urlParams";

export default class Cancel extends React.Component {
  componentDidMount() {
    const { destroyUser, getUser, redirect } = this.props;

    getUser(getUrlParams()).then((res) => {
      if (res.value.user.company) return redirect();

      return destroyUser(res.value.user);
    });
  }

  render() {
    return null;
  }
}

Cancel.propTypes = {
  destroyUser: PropTypes.func.isRequired,
  getUser: PropTypes.func.isRequired,
  redirect: PropTypes.func.isRequired,
};
